import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedMatchRefereesRequest } from '~/store/modules/matches/actions';
import { Responsive, Spinner } from '~/components';
import { Mobile, Desktop } from './responsive';
import EmptyPage from '~/pages/EmptyPage';

export default function ArbitrationTeam() {
  const dispatch = useDispatch();
  const {
    selectedMatch: { data: selectedMatch },
    referee: { data: referee, loading: loadingReferee },
    refereeAssistants: {
      data: refereeAssistants,
      loading: loadingRefereeAssistants,
    },
    publicFiles,
  } = useSelector(state => state.matches);
  const [selectedAssistant, setSelectedAssistant] = useState(0);

  useEffect(() => {
    if (selectedMatch && Object.keys(referee).length === 0) {
      dispatch(getSelectedMatchRefereesRequest(selectedMatch.id));
    }
  }, [dispatch, selectedMatch, referee]);

  const [optionSelected, setOptionSelected] = useState(1);

  const handleChangeReferee = ({ value }) => {
    setOptionSelected(value);
  };

  const refereeProps = {
    referee,
    selectedMatch,
    refereeAssistants,
    handleChangeReferee,
    optionSelected,
    selectedAssistant,
    setSelectedAssistant,
    publicFiles,
  };

  if (loadingReferee || loadingRefereeAssistants)
    return <Spinner isOpen isRelative />;
  if (
    Object.keys(referee).length > 0 ||
    Object.keys(refereeAssistants).length > 0
  )
    return (
      <Responsive
        sm={<Mobile {...refereeProps} />}
        lg={<Desktop {...refereeProps} />}
      />
    );
  return <EmptyPage />;
}
